import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { getCommonCodeLabel } from "../../../lib/store";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  campuses: any;
}

const ShowCampusModal: FC<IProps> = ({
  visible, setVisible, campuses
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('event.education.title2')}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <table className="table-custom text-center">
        <tbody>
          <tr>
            <th>{t('event.education.column9')}</th>
            <th>{t('common.menu.campus')}</th>
          </tr>
          {campuses?.map((item: any) => (
            <tr>
              <td>{getCommonCodeLabel('SY0004', item.sidoCode, 'ko')}</td>
              <td>{item.campusKorName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
  );
}

export default ShowCampusModal;
